export function getSpecification(values: any) {
   const specification: any = {};
   Object.keys(values).forEach((key) => {
      if (key.indexOf("::specification-field::") !== -1) {
         specification[key] = values[key];
      }
   });
   return specification;
}
